import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule, MatExpansionModule, MatIconModule, MatPaginatorModule, MatSelectModule, MatSortModule } from '@angular/material';
import { ProductResolver } from '../../../../../resolvers/product.resolver';
import { AccountService } from '../../../../../service/finzy-flex/account/account.service';
import { FinzyFlexDirectiveModule } from '../../../../../directives/finzy-flex/finzy-flex-directive.module';
import { EmptyLrsComponent } from './empty-lrs/empty-lrs.component';
import { FlexReportComponent } from './flex-report.component';
import { FlexReportsRoutingModule } from './flex-report.routing.module';
import { LrsDownloadPopupComponent } from './lrs-download-popup/lrs-download-popup.component';
import { ReportTableComponent } from './report-table/report-table.component';
import { PipesModule } from '../../../../../utils/pipes/pipes.module';
import { CommonSectionsModule } from '../../../../common/common-sections.module';

@NgModule({
    declarations: [
        FlexReportComponent,
        ReportTableComponent,
        LrsDownloadPopupComponent,
        EmptyLrsComponent,
    ],
    imports: [
        FlexReportsRoutingModule,
        MatIconModule,
        MatExpansionModule,
        CommonSectionsModule,
        FormsModule,
        MatPaginatorModule,
        FinzyFlexDirectiveModule,
        MatDatepickerModule,
        MatSelectModule,
        PipesModule,
        MatSortModule,
    ],
    providers: [ProductResolver, AccountService],
})
export class FlexReportModule {}